import { browserUtil } from '../common'
import { coreService } from '../service/core-service'
import { promoCodeService } from '../service/promo-code-service'
import { EventBusActionType, EventBusEntityType, eventBusUtil } from '../util/event-bus-util'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { PageContainer } from 'src/component/page-container/page-container'

export const CheckoutScreen = (): React.ReactElement => {
  const location = useLocation()
  useEffect(() => {
    const priceIdFromUrl = new URLSearchParams(location.search).get('priceId')
    coreService
      .getPrices()
      .then(async (prices) => {
        const priceId = priceIdFromUrl ?? prices[0].id
        // This screen goes straight to Stripe, so it is a checkout initiation in
        // its own right. An unlisted priceId still checks out, just with no value.
        eventBusUtil().emit({
          action: EventBusActionType.CREATE,
          entity: EventBusEntityType.CHECKOUT,
          meta: { price: prices.find((price) => price.id === priceId) },
        })

        const promoCode = promoCodeService.get()?.code
        try {
          return await coreService.createCheckoutSession(priceId, promoCode)
        } catch (err: any) {
          if (promoCode && err?.response?.data?.message === 'error.client.promo_code_invalid') {
            promoCodeService.clear()
            return coreService.createCheckoutSession(priceId)
          }
          throw err
        }
      })
      .then((url) => browserUtil.redirect(url))
  }, [location.search])
  return (
    <PageContainer>
      <h2>Please wait while we redirect you to the checkout page</h2>
    </PageContainer>
  )
}
